// The two audience icons, as SVG source strings.
//
// The field header chip is built in plain DOM (inside the BriefField node
// view) and the Fields drawer's chip is React, so the markup has to be
// shareable in both directions. Strings are the common denominator: the node
// view sets innerHTML, the React chip goes through dangerouslySetInnerHTML,
// and both end up with byte-identical markup and the same `.brief-aud`
// classes.
//
// 1.6px stroke, per the brand's icon rule. Colour is never the only signal:
// every chip carries an icon and a word.

import type { BriefAudience } from '../../../shared/briefFields';

export const AUDIENCE_ICONS: Record<BriefAudience, string> = {
  internal:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>',
  client:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="2.6"/></svg>',
};

export const AUDIENCE_CARET =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

export const AUDIENCE_CHECK =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
